import { Component } from '@angular/core';
import { NavController, NavParams, ViewController, LoadingController, ToastController } from 'ionic-angular';
import { StoryPage } from "../story/story";
import { ModalController } from "ionic-angular";
import { ChaptersPage } from "../chapters/chapters";
import { Subscription } from 'rxjs/Subscription';
import { CommentPage } from "../comment/comment";
import { StoryProvider } from '../../providers/story/story';
import { AuthDataProvider } from '../../providers/auth-data/auth-data';
import { AngularFireAuth } from 'angularfire2/auth';
import { AlertController } from 'ionic-angular';
import 'firebase/firestore';
//import { Storage } from '@ionic/storage';


@Component({
  selector: 'page-cover',
  templateUrl: 'cover.html',
})
export class CoverPage {
  public storie: any = {};
  public myLike: boolean;
  public dataUser: any
  public userAuth: any;
  public logged: any;
  public comments: any;
  public misLikes: any;
  public chapters: any;
  public length: any;
  public session: boolean;
  public userInfo: any;
  public AuthSubscription: Subscription;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public modalCtrl: ModalController,
    public storyProvider: StoryProvider,
    public authData: AuthDataProvider,
    public afAuth: AngularFireAuth,
    public alertCtrl: AlertController,
    public viewCtrl: ViewController,
    public loadingCtrl: LoadingController,
    private toast: ToastController,
    //private storage: Storage
  ) {

    let ion = this;
    ion.myLike = false
    //console.log("ESTATUS DE myLike", ion.myLike);


    let data = navParams.get('data');
    console.log("INFORMACION DE LA HISTORIA:", data)
    if (data) {
      ion.storie = data.storie; //console.log("INFORMACION STORIE: constructor", ion.storie);
      ion.navParams.data.historyID = ion.storie.$key;
      ion.misLikes = ion.storie.like; //console.log("Likes de esta Historia constructor", ion.storie.like);
      ion.length = data.storie.chapters.length; //console.log("Cantidad de Capitulos en esta Historia constructor", data.storie.chapters.length);
      ion.chapters = data.storie.chapters; //console.log("Capitulos de esta Historia: constructor", data.storie.chapters);
      ion.comments = data.storie.comments;// console.log("Comentarios de esta Historia: constructor", ion.comments);

      ion.session = data.session; //console.log("Hay usuario Logueado: constructor", ion.session);
      ion.userInfo = data.userInfo; //console.log("Informacion de Usuario Logueado: constructor", ion.userInfo);
    }
  
        if (ion.navParams.data.historyID) {
      ion.getStorieFromUrl(ion.navParams.data.historyID);
      ion.session = true;

      this.AuthSubscription = this.afAuth.authState.subscribe(userAuth => {

        //console.log("dejame entender algo", userAuth);
        if (userAuth && userAuth.email && userAuth.uid) {
          console.log('auth true login, moving HomePage', userAuth.email);
          // this.authData.getUserProfile().then(function (res) {
          //   ion.userInfo = res;
          // });

          this.authData.getUserEmail(userAuth.email).then(function (resEmail) {
            ion.userInfo = resEmail;
            // console.log("julio info del arreglo de user retorno", ion.userInfo);
          })

          this.authData.setUserData().then(() => {
            this.AuthSubscription.unsubscribe();
            ion.session = true;
            this.toast.create({
              message: 'Bienvenidos a DirtyTalk, ' + userAuth.email,
              duration: 3000
            }).present();
          });

          // ion.authData.getUserEmail(this.afAuth.auth.currentUser.email).then(resdevice => {
          ion.authData.getUserProfile().then(resdevice => {
            ion.userInfo = resdevice;
          });

        } else {
          this.AuthSubscription.unsubscribe();
          ion.session = false;
          this.authData.getUserProfile().then(function (res) {
            ion.userInfo = res;
            // console.log("auth false, continue login!", ion.userInfo)
          });
        }
      });
    }
    /// Checking chapters to show chapters link
    this.checkChapter();

    if (data) {
      if (data.userInfo) {
        if (ion.userInfo.likes) {
          for (let ii = 0; ii < ion.userInfo.likes.length; ii++) {
            console.log("Likes de este Usuario", ion.userInfo.likes[ii]);
            if (ion.userInfo.likes[ii].storyID == ion.storie.$key) {
              ion.myLike = ion.userInfo.likes[ii].like
            }
          }
        } else {
          console.log("No existe usuario Logueado");
        }
      }
    }

    if (ion.userInfo) {
      this.logged = true;
    } else {
      this.logged = false;
    }

  }

  ionViewWillEnter() {
    console.log("PROBANDO EL ionViewWillEnter");
    let data = this.navParams.get('data');
    console.log("INFORMACION DE LA HISTORIA DESDE EL ionViewWillEnter:", data)

  }

  ionViewDidEnter() {
    console.log("PROBANDO EL ionViewDidEnter");
  }

  checkChapter() {
    if (this.chapters && this.length > 1) {
      this.length = true;
    } else {
      this.length = false;
    }
  }

  goBack() {
    this.navCtrl.pop();
  }

  ReadComment(storie) {
    let ion = this;
    //console.log("mensaje de storie", storie)
    ion.navCtrl.push(CommentPage, {
      data: {
        comments: ion.comments,
        id_storie: storie,
        session: ion.session,
        userinfo: ion.userInfo
      }
    });
  }

  Read(storie) {
    let ion = this;
    //console.log("mensaje de storie", ion.storie)
    ion.navCtrl.push(StoryPage, {
      data: {
        storie: ion.storie,
        session: ion.session,
        userinfo: ion.userInfo
      }
    });
  }

  sendlike() {
    let ion = this;
    console.log("LIKE LIKE", ion.myLike)
    let currentLike = 0
    if (ion.myLike) {
      currentLike = ion.storie.like - 1
      ion.myLike = !ion.myLike
    } else {
      currentLike = ion.storie.like + 1
      ion.myLike = !ion.myLike
    }
    ion.storyProvider.setLike(ion.storie.$key, currentLike, ion.userInfo, ion.myLike).then(res => {
      console.log("Document successfully written!", currentLike);
      ion.storie.like = currentLike;

    }).catch(function (error) {
      console.error("Error writing document: ", error);
    });
  }

  getStorieFromUrl(historyID) {
    let ion = this;
    ion.storyProvider.getStory(historyID).then(res => {
      ion.storie = res;

      console.log('******************testtttttttttttttttttt******************', ion.storie, res);
    }).catch(function (error) {
      console.error("Error getting story document: ", error);
    });
  }

  //Funcion para abreviar las cantidades de Likes y expresarlos en K o M segun sea el caso.
  calculateNumber(number) {
    if (number == 0) {
      return 0;
    }
    else {
      if (number <= 999) {
        return number;
      }
      else if (number >= 1000 && number <= 999999) {
        number = (number / 1000).toFixed(1);
        return number + 'K';
      }
      else if (number >= 1000000 && number <= 999999999) {
        number = (number / 1000000).toFixed(1);
        return number + 'M';
      }
      else if (number >= 1000000000 && number <= 999999999999) {
        number = (number / 1000000000).toFixed(1);
        return number + 'B';
      }
      else
        return number;
    }
  }

  GoToChapters() {
    let ion = this;
    console.log("QUE LE PASO A CHAPTER SON ion.chapters", ion.chapters);
    console.log("QUE LE PASO A CHAPTER SON this.storie", this.storie);

    const modal = this.modalCtrl.create(ChaptersPage, {
      data: {
        chapters: ion.chapters,
        storie: this.storie
      }
    });
    modal.onDidDismiss(dataStory => {
      if (dataStory) {
        console.log("QUE INFO ESTOY ENVIANDO CON dataStory ", dataStory);
        console.log("QUE INFO ESTOY ENVIANDO CON dataStory.storie ", dataStory.storie);
        console.log("QUE INFO ESTOY ENVIANDO CON dataStory.storie.chapters ", dataStory.chaptersIDs);
        ion.storie = dataStory.storie;
        ion.comments = dataStory.storie.comments;
        //ion.chapters = dataStory.storie.chapters;
      }
    });
    modal.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/cover/cover.ts